import { useFormik } from 'formik';
import { initialValues } from './formData';
import { cleanObj } from '../../../../../shared/utils/objects';
import { ISelect, ParamEnum } from '../../../../../shared/types/shared';
import { useEffect, useState } from 'react';
import { asyncGetLabelParams } from '../../../../../services/param.service';
import { SwitchFilter } from '../../../../../shared/types/modules/switch';
import { asyncGetUsers } from '../../../../../services/users.service';

export const useSwitchFilters = (onFilter?: (data: SwitchFilter) => void) => {
    const [typification1, setTypification1] = useState<ISelect[]>([]);
    const [typification2, setTypification2] = useState<ISelect[]>([]);
    const [users, setUsers] = useState<ISelect[]>([]);

    const onSubmit = (data: SwitchFilter) => {
        if (onFilter) onFilter(cleanObj(data) || {});
    };

    const formik = useFormik({
        initialValues,
        onSubmit,
    });

    useEffect(() => {
        asyncGetLabelParams(ParamEnum.SWITCH_TYPIFICATION1).then((params) =>
            setTypification1(params.map(({ name }) => ({ id: name, name })))
        );
        asyncGetLabelParams(ParamEnum.SWITCH_TYPIFICATION2).then((params) =>
            setTypification2(params.map(({ name }) => ({ id: name, name })))
        );
    }, []);

    useEffect(() => {
        asyncGetUsers()
            .then((body: any) => {
                if (body && typeof body.items === 'object') {
                    setUsers(getDataUsers([body.items]));
                } else {
                    console.error('Not found data');
                }
            })
            .catch((error) => {
                console.error('Error al obtener usuarios:', error);
            })
            .finally(() => console.log('Cargando usuarios terminado'));
    }, []);

    function getDataUsers(users: any[]) {
        if (users.length > 0) {
            const usuarios = users[0].items;
            if (usuarios && usuarios.length > 0) {
                return usuarios.map((user: any) => ({
                    id: user.name,
                    name: user.name,
                }));
            } else {
                return [];
            }
        } else {
            return [];
        }
    }

    return {
        formik,
        typification1,
        typification2,
        users,
    };
};
